import { ConfigServiceProvider } from '../config-service/config-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';

@Injectable()
export class DisplayServiceProvider {
  public screens: any = {};
  public screensType = 'default';
  public overridenWelcome = null;
  public newBadges = [];
  public newLevels = [];
  public screensUrl = '../../../../assets/screens/screens.json';

  constructor(private configService: ConfigServiceProvider, private storageService: StorageServiceProvider, public http: HttpClient) {}

  load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('screens'))
        // .get(this.screensUrl)
        .toPromise()
        .then((response: any) => {
          this.screens = response.params;
          this.storageService.setObject('screens', this.screens);
          resolve();
        })
        .catch((error) => {
          console.log('errr', error);
          reject(error);
        });
    });
  }

  loadLocal() {
    return new Promise<void>((resolve, reject) => {
      this.storageService.getObject('screens').then(
        (response) => {
          this.screens = response;
          resolve();
        },
        (errors) => {
          reject(errors);
        },
      );
    });
  }

  overrideWelcome(screen) {
    this.overridenWelcome = screen;
  }

  getWelcomeScreen() {
    if (this.newLevels && this.newLevels.length > 0) {
      this.newLevels.splice(0, 1);
    } else if (this.newBadges && this.newBadges.length > 0) {
      this.newBadges.splice(0, 1);
    } else if (this.overridenWelcome) {
      let welcome = this.overridenWelcome;
      this.overridenWelcome = null;
      return welcome;
    } else if (this.screens[this.screensType]['welcome'] === true) {
      return 'main.welcome';
    } else {
      return this.screens[this.screensType]['start'] || null;
    }
  }

  getStartingScreen() {
    return this.screens[this.screensType]['start'] || null;
  }

  getScreenComponent(screen, component) {
    if (!this.screens[this.screensType]['start'] && !this.screens[this.screensType][screen]) {
      return null;
    } else {
      return this.screens[this.screensType][component];
    }
  }

  isScreenComponentVisible(screen, component) {
    let componentData = this.getScreenComponent(screen, component);
    if (componentData !== null) {
      return componentData.visible || false;
    } else {
      return false;
    }
  }

  setNewLevels(levels) {
    this.newLevels = levels;
  }

  setScreenType(type) {
    this.screensType = type;
  }

  setNewBadges(badges) {
    this.newBadges = badges;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/display-service/display-service.ts